















































































































































































































































































import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import Avatar from 'vue-avatar';
import { setProp } from '@shared/helpers/operators';
import TableFooter from '@shared/components/tables/table-footer/table-footer.vue';
import { ContactRelation } from '@contacts/interfaces/contact-relation';

const ConfirmationModal = () =>
  import('@shared/components/modals/confirmation-modal/confirmation-modal.vue');
const StdForm = () => import('../../auto-form/std-form/std-form.vue');
const EntityDeleteModalProvider = () =>
  import('@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue');
import { Contact } from '@contacts/interfaces/contact';
import { v4 as uuidv4 } from 'uuid';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import ContactForm from '@contacts/components/forms/contact-form/contact-form.vue';
library.add(faPlus);

@Component({
  name: 'bpc-team-list-group-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-std-form': StdForm,
    'bpc-entity-table': EntityTable,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-confirmation-modal': ConfirmationModal,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-drawer-modal': DrawerModal,
    'bpc-table-footer': TableFooter,
    'bpc-contact-form': ContactForm,
    Avatar,
  },
})
export default class TeamListGroupInput extends mixins(AbstractField, AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    stdContactForm: InstanceType<typeof ContactForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
    };
  };
  @Prop(Array) readonly value: object[];

  @Prop(Array) declare readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;
  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: string[];
  @Prop(String) readonly manageFrom: string;
  @Prop(String) readonly emptyLabel: string;

  relationModel: ContactRelation = null;

  get model(): object[] {
    return this.value;
  }
  set model(val: object[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  public entity: any = null;
  public entityName = 'contact-relation';
  public pluralEntityName = 'contact-relations';
  public loader: boolean = true;

  // LIFECYCLE
  mounted() {
    /* NOTE: refresh teams and groups when a relation is edited */
    this.$root.$on('contact-relation-table-input-form-saved', val => {
      this.$refs.provider.getEntities();
    });

    this.$root.$on('relationCategoryChangedFromContactRelationForm', category => {
      this.setEmailValuesFromCategory(category);
    });
  }

  destroyed() {
    this.$root.$off('contact-relation-table-input-form-saved');
    this.$root.$off('relationCategoryChangedFromContactRelationForm');
  }

  setEmailValuesFromCategory(category) {
    if (category && this.$refs.stdForm?.formModel) {
      setProp(this.$refs.stdForm.formModel, 'booking_emails', category?.booking_emails || false);
      setProp(
        this.$refs.stdForm.formModel,
        'accounting_emails',
        category?.accounting_emails || false,
      );
      setProp(this.$refs.stdForm.formModel, 'other_emails', category?.other_emails || false);
    }
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  public get resolvedConfigFileName(): string {
    const fileName = this.entityName.replaceAll('-', '_');
    return this.configFileName
      ? this.configFileName
      : this.tenantType === 'center'
      ? fileName
      : `${fileName}_for_club`;
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  getMode(): string {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return 'api';
    } else {
      return 'storage';
    }
  }
  updateModel(): void {
    this.model = this.$refs.provider ? this.$refs.provider.items : null;
  }

  finishLoader(): void {
    this.loader = false;
  }

  onFormSave() {
    this.loader = true;
    console.log('Saving');
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      this.$refs.stdForm.formModel[filter['filterField']] = filter['value'];
    }
    this.$refs.stdForm.saveEntity();
  }

  onNew() {
    this.entity = null;
    this.showForm = true;
    // this.$bvModal.show('modal-resource-form');
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  avatar(value) {
    if (value instanceof Array) return value[0].url;
    else if (value instanceof Object) return value.url;
    else return null;
  }

  get contactId() {
    const filter = this.filters.find(filter => filter['filterField'] === 'contact_id');
    return filter ? filter['value'] : null;
  }

  teamMembers(relations) {
    const members = [];

    relations.forEach(rel => {
      if (rel.contact_id === this.contactId) {
        rel.relatedContact['relation_category'] = rel.contactRelationCategory?.name
          ? rel.contactRelationCategory?.name
          : '';
        rel.relatedContact['relation_comment'] = rel.description;
        members.push(rel.relatedContact);
      } else {
        rel.contact['relation_category'] = rel.contactRelationCategory?.name
          ? rel.contactRelationCategory?.name
          : '';
        rel.contact['relation_comment'] = rel.description;
        members.push(rel.contact);
      }
    });
    return members;
  }

  contactTitleData(contact) {
    let title = contact.fullname;
    if (contact.relation_category) {
      title += ` (${contact.relation_category}) `;
    }
    return title;
  }

  contactDetailData(data) {
    let subtitle = '';
    if (data) {
      subtitle = subtitle + data.phone1 ? `${data.phone1}` : '';
      subtitle = subtitle + data.phone1 ? ` - ` : '';
      subtitle = subtitle + data.email1 ? `${data.email1}` : '';
    }
    return subtitle;
  }

  teamMemberFormConfigName = null;
  onCreateTeamAction() {
    if (this.manageFrom === 'members') {
      this.teamMemberFormConfigName = 'team_group_related';
    } else if (this.manageFrom === 'teams') {
      this.teamMemberFormConfigName = 'create_team_group_responsible';
    }
    this.onNew();
  }

  onEditTeamRelation(contactRelation) {
    if (this.manageFrom === 'members') {
      this.teamMemberFormConfigName = 'team_group_related';
    } else if (this.manageFrom === 'teams') {
      this.teamMemberFormConfigName = 'edit_team_group_responsible';
    }
    this.onEdit({ item: contactRelation });
  }

  onRelationLoaded() {
    setProp(this.$refs.stdForm.formModel, 'main_contact_id', this.formModel['id']);
    if (this.manageFrom === 'members') {
      setProp(this.$refs.stdForm.formModel, 'related_contact_id', this.formModel['id']);
      this.$nextTick().then(() => {
        const contactRelationCategory = JSON.parse(
          JSON.stringify(this.relationModel.contactRelationCategory),
        );
        this.$root.$emit('filterContactRelationCategories', this.relationModel?.contact?.type);
        setProp(this.relationModel, 'contactRelationCategory', contactRelationCategory);
      });
    } else if (this.manageFrom === 'teams') {
      setProp(this.$refs.stdForm.formModel, 'contact_id', this.formModel['id']);
      this.$nextTick().then(() => {
        const contactRelationCategory = JSON.parse(
          JSON.stringify(this.relationModel.contactRelationCategory),
        );
        this.$root.$emit('filterContactRelationCategories', this.formModel['type']);
        setProp(this.relationModel, 'contactRelationCategory', contactRelationCategory);
      });
    }
  }

  get createTeamGroupResponsibleSavePath(): string {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('contact-relations');
    return `${basePath}/bulk-add-to-team-or-group`;
  }

  get relationContact() {
    return this.relationModel?.contact;
  }

  get emptyListLabel() {
    return this.emptyLabel ? this.$t(this.emptyLabel) : this.$t('global.team_group.empty.label');
  }

  @Watch('relationContact', { deep: true })
  onRelationContactChange(contact) {
    this.$root.$emit('filterContactRelationCategories', contact ? contact['type'] : null);
  }

  // Edit contact clicking on it
  clickedContact: Contact;
  showContactModalId = uuidv4();
  showContactForm: boolean = false;
  isSavingContactForm: boolean = false;
  disabledContactForm: boolean = true;
  clickOnLink(contact) {
    this.clickedContact = contact;
    this.disabledContactForm = true;
    this.showContactForm = true;
  }
  getContactModalTitle() {
    return this.$t('global.modals.edit') + ' ' + this.$t('global.models.contact.name');
  }
  onContactFormEdit() {
    this.disabledContactForm = false;
  }
  onContactFormClose() {
    this.showContactForm = false;
    this.isSavingContactForm = false;
  }
  onContactFormSave() {
    this.isSavingContactForm = true;
    this.$refs.stdContactForm.saveEntity();
  }
  onContactFormSaved() {
    this.$refs.provider.getEntities();
    this.onContactFormClose();
  }
  onContactSavingEntity(event) {
    this.isSavingContactForm = event;
  }
}
